import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab8d2540"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-[#16161d] leading-6 text-left" }, " Aprovar essa troca irá cancelar outros convites. Deseja continuar? ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#52526f] leading-[18px] text-left" }, " Esta ação não pode ser desfeita. ", -1))
const _hoisted_4 = { class: "flex flex-col gap-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-[#d8d8e2]" }, null, -1))
const _hoisted_6 = { class: "text-sm text-[#16161d] leading-[18px] text-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "flex flex-col gap-2 bg-[#f0f0f4] rounded-lg p-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-bold text-[#52526f] uppercase tracking-wide leading-[14px] text-left" }, " O que será cancelado ", -1))
const _hoisted_11 = { class: "flex gap-1.5 text-sm text-[#16161d] leading-[18px]" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold whitespace-nowrap" }, "Profissional que está passando:", -1))
const _hoisted_13 = { class: "flex gap-1.5 text-sm text-[#16161d] leading-[18px]" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold whitespace-nowrap" }, "Plantões:", -1))
const _hoisted_15 = { class: "flex gap-1.5 text-sm text-[#16161d] leading-[18px]" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold whitespace-nowrap" }, "Convidados com aceite ativo:", -1))
const _hoisted_17 = { class: "flex gap-1.5 text-sm text-[#16161d] leading-[18px]" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Profissionais que querem assumir:", -1))
const _hoisted_19 = { class: "flex flex-col gap-1.5" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-[#da1e28]" }, "*", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-[#52526f] leading-4 text-left" }, " O motivo é registrado no histórico do plantão ", -1))
const _hoisted_22 = { class: "flex flex-col gap-4" }
const _hoisted_23 = {
  key: 0,
  "data-testid": "schedule-conflict-alert",
  class: "flex flex-col gap-2 rounded-lg p-3 bg-[#fdecec] border border-[#da1e28] text-left"
}
const _hoisted_24 = { class: "text-sm text-[#16161d] leading-[18px]" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Conflito de agenda:", -1))
const _hoisted_26 = { class: "flex flex-col gap-1" }
const _hoisted_27 = {
  "data-testid": "approval-reminder-callout",
  class: "flex items-start gap-2 rounded-lg p-3 bg-[#edf5ff] border border-[#0f62fe]"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#16161d] leading-[18px] text-left" }, " Ao aprovar, você confirma a autorização do profissional para este plantão e garante a atualização no sistema ou planilha da contratante. ", -1))
const _hoisted_29 = { class: "flex items-center justify-between" }

import { ref, computed } from 'vue'
import { format, parseISO } from 'date-fns'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import {
  PackageResponse,
  InviteResponseV2,
  DoctorSummary,
  ScheduleConflictsSummary
} from '@/Network/Types/Responses/HandoverInviteResponses'
import { getFirstAndSecondName } from '@/utils/getFirstAndSecondName'
import { mdiAlertCircle, mdiInformationOutline } from '@mdi/js'

interface KillSwitchImpact {
  hasConflicts: boolean
  originDoctor: DoctorSummary
  affectedShiftsCount: number
  affectedShiftsDescription: string
  activeAcceptanceCount: number
  candidatesCount: number
}

const OTHER_OPTION = 'Outro (especificar)'


export default /*#__PURE__*/_defineComponent({
  __name: 'KillSwitchConfirmModal',
  props: {
    modelValue: { type: Boolean },
    packageData: {},
    candidate: {},
    impact: {},
    loading: { type: Boolean },
    confirmText: { default: 'Cancelar trocas e aprovar convite' },
    scheduleConflicts: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;

const reasonOptions = [
  'Ajuste operacional da escala',
  'Erro na configuração do plantão',
  'Solicitação do médico responsável',
  'Mudança de requisito da unidade',
  OTHER_OPTION
]





const selectedReason = ref<string | null>(null)
const customReason = ref('')

const requiredRule = (v: string) => !!v || 'Campo obrigatório'

const stationCount = computed(() => props.packageData.stations.length)
const requesterName = computed(() => getFirstAndSecondName(props.packageData.requester.name))
const candidateName = computed(() => getFirstAndSecondName(props.candidate.doctor?.name ?? ''))

const hasScheduleConflicts = computed(
  () => !!props.scheduleConflicts && props.scheduleConflicts.conflicts.length > 0
)

const formatConflictDate = (dateStr: string) => {
  try {
    return format(parseISO(dateStr), 'dd/MM/yyyy')
  } catch {
    return dateStr
  }
}

const finalReason = computed(() => {
  if (selectedReason.value === OTHER_OPTION) return customReason.value.trim()
  return selectedReason.value ?? ''
})

const isFormValid = computed(() => {
  if (!selectedReason.value) return false
  if (selectedReason.value === OTHER_OPTION && !customReason.value.trim()) return false
  return true
})

const handleConfirm = () => {
  if (!isFormValid.value) return
  emit('confirm', finalReason.value)
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.modelValue,
    "max-width": "max-w-[600px]",
    "show-close-button": true,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          icon: _unref(mdiAlertCircle),
          size: "40",
          color: "#da1e28"
        }, null, 8, ["icon"]),
        _hoisted_2,
        _hoisted_3
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_22, [
        (hasScheduleConflicts.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("p", _hoisted_24, [
                _hoisted_25,
                _createTextVNode(" Dr(a). " + _toDisplayString(_ctx.scheduleConflicts?.doctorName) + " já está alocado(a) em " + _toDisplayString(_ctx.scheduleConflicts?.conflicts.length) + " plantão(ões) que se sobrepõe(m) a este convite: ", 1)
              ]),
              _createElementVNode("ul", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleConflicts?.conflicts, (conflict, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "text-sm text-[#16161d] leading-[18px]"
                  }, " • " + _toDisplayString(formatConflictDate(conflict.date)) + " · " + _toDisplayString(conflict.startHour) + "—" + _toDisplayString(conflict.endHour) + " · " + _toDisplayString(conflict.healthUnitName) + " — " + _toDisplayString(conflict.scheduleName), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_v_icon, {
            icon: _unref(mdiInformationOutline),
            size: "18",
            color: "#0f62fe",
            class: "shrink-0 mt-0.5"
          }, null, 8, ["icon"]),
          _hoisted_28
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(OutlineButton, {
            text: "Cancelar aprovação",
            width: "auto",
            height: "48px",
            disabled: _ctx.loading,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
          }, null, 8, ["disabled"]),
          _createVNode(_component_v_btn, {
            color: "#da1e28",
            variant: "flat",
            height: "48",
            class: "normal-case font-bold text-sm text-white rounded px-4",
            disabled: !isFormValid.value || _ctx.loading,
            loading: _ctx.loading,
            onClick: handleConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.confirmText), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(" Tem certeza que aprovar a troca de " + _toDisplayString(stationCount.value) + " plantões do Dr(a). " + _toDisplayString(requesterName.value) + " para o Dr(a). " + _toDisplayString(candidateName.value) + "? Um ou mais plantões do convite também estão presentes em outros convites de troca, e aprovar essa irá cancelar os outros pedidos ", 1),
          _hoisted_7,
          _hoisted_8,
          _createTextVNode(" Os médicos serão notificados do cancelamento ")
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", null, _toDisplayString(_unref(getFirstAndSecondName)(_ctx.impact.originDoctor.name)) + " · CRM " + _toDisplayString(_ctx.impact.originDoctor.crm), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", null, _toDisplayString(_ctx.impact.affectedShiftsDescription), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("span", null, _toDisplayString(_ctx.impact.activeAcceptanceCount) + " médicos", 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", null, _toDisplayString(_ctx.impact.candidatesCount) + " candidato" + _toDisplayString(_ctx.impact.candidatesCount !== 1 ? 's' : ''), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_v_select, {
            modelValue: selectedReason.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedReason).value = $event)),
            items: reasonOptions,
            label: "Motivo do cancelamento",
            variant: "outlined",
            density: "comfortable",
            rules: [requiredRule],
            "hide-details": "auto"
          }, {
            label: _withCtx(() => [
              _createTextVNode(" Motivo do cancelamento "),
              _hoisted_20
            ]),
            _: 1
          }, 8, ["modelValue", "rules"]),
          (selectedReason.value === OTHER_OPTION)
            ? (_openBlock(), _createBlock(_component_v_textarea, {
                key: 0,
                modelValue: customReason.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customReason).value = $event)),
                variant: "outlined",
                density: "comfortable",
                placeholder: "Digite o motivo do cancelamento...",
                rules: [requiredRule],
                "hide-details": "auto",
                rows: "3",
                "auto-grow": "",
                class: "mt-1"
              }, null, 8, ["modelValue", "rules"]))
            : _createCommentVNode("", true),
          _hoisted_21
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})